
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

interface FAQItem {
  question: string;
  answer: string | React.ReactNode;
}

const FAQSection = () => {
  const faqs: FAQItem[] = [
    {
      question: "Which kind of roles and skills are supported on Cutshort?",
      answer: "Cutshort is best to hire for product engineering/data/product roles in 1 to 12 year experience range where finding right talent from thousands of potential candidates is often a challenge. Skills wise, we see hirings happening across AI, ML, Java, React, Data, SDET etc."
    },
    {
      question: "What kind of companies use Cutshort?",
      answer: "Cutshort is designed for product engineering companies that includes GCCs (like Deepintent and Blackhawk Network), startups (like Sprinto and Shiprocket) and premium IT consulting players (like Fractal & Thoughtworks)."
    },
    {
      question: "What kind of talent pool Cutshort has?",
      answer: "Over the last 10 years, 3.5M premium professionals have signed up on Cutshort after conventional job portals failed to offer them great opportunities and great experience. India has 6M IT professionals, out of which 2M are already registered on Cutshort."
    },
    {
      question: "Is Cutshort an AI Screening tool?",
      answer: "Cutshort is a complete sourcing+screening platform. We do have a separate AI Screener tool that you can use along with or without Cutshort."
    },
    {
      question: "Can my team use the Cutshort platform like we use Naukri or LinkedIn?",
      answer: <>Absolutely. They will be able to source better talent by spending 50% less effort. You can sign up <a href="http://cutshort.io/?auth=employer" target="_blank" rel="noopener noreferrer" className="text-cs-primary hover:underline">here</a>.</>
    }
  ];

  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-cs-dark-grey mb-3">Frequently Asked Questions</h2>
          <p className="text-lg text-cs-medium-grey">Everything you need to know about Cutshort</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`} className="border-b border-gray-200">
                <AccordionTrigger className="text-lg font-medium text-cs-dark-grey py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-cs-medium-grey text-base pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
